module.exports = __webpack_public_path__ + "static/vol1-77de950cf7d1c7afb408c0672923633b.png";